
//动态扩散圆
function DynamicCircleBMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined; //颜色
    this._colorSubscription = undefined;

    this.color = options.color;
    this.time = options.time; //速度
    this.count = options.count;
    this.gradient = options.gradient; //
}
Object.defineProperties(DynamicCircleBMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color'),
    time: Cesium.createPropertyDescriptor('time'),
    count: Cesium.createPropertyDescriptor('count'),
    gradient: Cesium.createPropertyDescriptor('gradient')
});
DynamicCircleBMaterialProperty.prototype.getType = function (time) {
    return  Cesium.Material.DynamicCircleBType;
}
DynamicCircleBMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    //1、property 2、time 3、default 4、result
    result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.RED, result.color);
     //1、property 2、time 3、default 4、result
    result.time=Cesium.Property.getValueOrDefault(this.time, time, 10, result.time);
    result.count=Cesium.Property.getValueOrDefault(this.count, time, 2, result.count);
    result.gradient=Cesium.Property.getValueOrDefault(this.gradient, time, 0.2, result.gradient);
    return result;
}

DynamicCircleBMaterialProperty.prototype.equals = function (other) {
    return this === other ||
        (other instanceof DynamicCircleBMaterialProperty &&
            Cesium.Property.equals(this._color, other._color))
}


export default DynamicCircleBMaterialProperty;